module.exports = __webpack_public_path__ + "img/crypto-seed-phrase-storage_B096HVDHQ8.b4f97943.jpg";